import { Navigate, Route, Router } from '@solidjs/router';
import { getSlug, HostedAuthPaths } from '~/components/AppRouter/utils.ts';
import WorkspaceAppRoutes from '~/components/AppRouter/WorkspaceAppRoutes.tsx';
import AdminPortalAppRoutes from '~/components/AppRouter/AdminPortalAppRoutes.tsx';
import AppContainer from '~/components/AppContainer';
import { Component, lazy } from 'solid-js';
import UiHandlerRoutes from '~/components/AppRouter/UiHandlerRoutes.tsx';
import HostedAppRoutes from '~/components/AppRouter/HostedAppRoutes.tsx';
import { isScalekitWorkspaceEnvironment } from '~/utils/commonUtils.ts';
import EnvAppPagesRoutes from '~/components/AppRouter/EnvAppPagesRoutes.tsx';

const NotFound404 = lazy(() => import('~/pages/NotFound404'));

export default function AppRouter() {
  return (
    <Router root={AppContainer as Component}>
      <WorkspaceAppRoutes />
      <AdminPortalAppRoutes />
      <UiHandlerRoutes />
      <HostedAppRoutes />
      <EnvAppPagesRoutes /> {/* Environment app page routes */}
      {/*
       * Fallback route redirects to dashboard
       */}
      <Route
        path="/"
        component={() => (
          <Navigate
            href={
              isScalekitWorkspaceEnvironment()
                ? getSlug.workspaceBaseNamespace()
                : getSlug.hostedAuthPages(HostedAuthPaths.LOGIN, true)
            }
          />
        )}
      />
      {/*
       * 404 handling
       */}
      <Route
        path="*"
        component={() => <NotFound404 />}
      />
    </Router>
  );
}
